// extracted by mini-css-extract-plugin
module.exports = {"templateContainer":"Template_templateContainer__1ZNUO","templateContentContainer":"Template_templateContentContainer__1o4bZ","templateChildren":"Template_templateChildren__1cPp6"};